import { render, staticRenderFns } from "./ManageNews.vue?vue&type=template&id=ad57912e"
import script from "./ManageNews.vue?vue&type=script&lang=js"
export * from "./ManageNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports